<!--
 * @Author: Suroc
 * @Date: 2024-07-09 09:39:06
 * @LastEditTime: 2024-09-19 10:02:11
 * @Description: APP
-->
<script setup>
import DefaultLayout from '@/layouts/layout.vue'
import { initContract } from '@/contract'
// 初始化合约
onMounted(async () => {
  await initContract()
})
</script>

<template>
  <DefaultLayout />
</template>

<style scoped>

</style>
